import React from "react";
import PropTypes from "prop-types";
import { Newspaper } from "lucide-react";
import { NoData } from "../../../../Components/ui";

const NewsEmptyState = ({
  hasSearchQuery = false,
  onResetFilters,
}) => {
  return (
    <NoData
      title={hasSearchQuery ? "No Matching News Found" : "No News Articles Published"}
      description={
        hasSearchQuery
          ? "We couldn't find any articles matching your search keyword or selected category filter. Try clearing filters to see all news."
          : "There are currently no published articles or updates available. Please check back later for new ecosystem announcements."
      }
      icon={<Newspaper size={32} />}
      actionText={hasSearchQuery ? "Clear Search & Filters" : undefined}
      onAction={hasSearchQuery ? onResetFilters : undefined}
      minHeight={320}
    />
  );
};

NewsEmptyState.propTypes = {
  hasSearchQuery: PropTypes.bool,
  onResetFilters: PropTypes.func,
};

export default NewsEmptyState;
